import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GenericSelectOptions } from "src/app/models/shared/generic-select-options";
import { CustomerService } from "src/app/services/customer/customer.service";

@Injectable()
export class TaxScheduleResolver  {
    
    constructor(private customerService: CustomerService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<GenericSelectOptions>> {
        const response = this.customerService.getTaxSchedule().pipe(map(response => { 
            if (response.success) {
                return response.payload;
            }
            else {
                return <GenericSelectOptions> { defaultOption: '', options: []};
            }
        }));
        const responsePromise = new Promise<Observable<GenericSelectOptions>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }
}